import React from 'react';
import '../assets/styles/global.css';

const DisableButton = ({ text, className, onClick, ...props }) => {
  return (
    <button
      className={`button-md ${className} disable-bg`}
      onClick={onClick}
      disabled
      {...props}
    >
      {text}
    </button>
  );
};

export default DisableButton;
